import React, { FC, useCallback, useState } from 'react';
import { Text, View } from 'react-native';
import MachinesProvider from '@v2/pages/machines/common/providers/MachinesProvider/MachinesProvider';
import { TimelineItemsList } from '@v2/pages/machines/modules/timeline/components/TimelineItemsList/TimelineItemsList';
import { NavigationProps } from '@interfaces/navigation';
import { MACHINES_PAGES_CONTAINER_STYLES } from '@v2/pages/common/constants/base.constants';
import Links from '@components/ncFiles/components/links';
import { ReducerEntityWithLoadingState } from '@v2/pages/common/interfaces';
import { NCFileSearchItem } from '@interfaces/search';
import { connect } from 'react-redux';
import { getNCFileById } from '@reducers/manufacture';
import { useFocusEffect } from '@react-navigation/native';
import { Machine } from '@interfaces/machines';
import { GetNCFileById } from '@interfaces/methods';

interface NCFileLinksProps extends NavigationProps {
  getNCFileById: GetNCFileById;
  selectedItem: Machine;
}

const NCFileLinksComponent: FC<NCFileLinksProps> = ({ lg, getNCFileById, selectedItem }) => {
  const [ncFile, setNcFile] = useState<NCFileSearchItem | null>(null);
  const [loading, setLoading] = useState<boolean>(false);

  const ncFileId = selectedItem?.machineStatus?.ncFileId;
  useFocusEffect(
    useCallback(() => {
      if (ncFileId == null) return;

      setLoading(true);

      (async () => {
        try {
          const ncFileData = await getNCFileById(selectedItem?.machineStatus?.ncFileId);
          if (ncFileData) {
            setNcFile(ncFileData);
          }
        } catch (e) {
          console.error(e);
        } finally {
          setLoading(false);
        }
      })();
    }, [ncFileId])
  );

  return (
    <MachinesProvider
      lg={lg}
      panelViewMode={false} //TODO: remove this later
      onBack={() => {}}
      getList={(props) => <TimelineItemsList {...props} />}
    >
      <View style={MACHINES_PAGES_CONTAINER_STYLES}>
        <Links isLoading={loading} links={ncFile?.links ?? []} />
      </View>
    </MachinesProvider>
  );
};

const NCFileLinks = connect(({ machines: { selectedItem } }) => ({ selectedItem }), { getNCFileById })(NCFileLinksComponent);

export { NCFileLinks };
